export default "__VITE_PUBLIC_ASSET__0ef89e3a__"